// @ts-nocheck


import { classesRuntime, statesRuntime } from "../../stylable-esm-runtime.js";



var _namespace_ = "CollectionPage2667572599";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st: import("@stylable/runtime").STFunction = _style_;

export var namespace = _namespace_;
export var classes = {"root":"CollectionPage2667572599__root"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-page-header-padding-horizontal":"--wds-page-header-padding-horizontal","wds-page-header-padding-horizontal-small":"--wds-page-header-padding-horizontal-small","wds-color-fill-surface-sunken":"--wds-color-fill-surface-sunken","wds-space-300":"--wds-space-300"}; 




